import { Component, HostListener, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SidebarService } from '../../services/sidebar.service';
import { filter } from 'rxjs';
import { Location } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  imports: [TranslateModule]
})
export class HeaderComponent {
  isOpen = false;
  showBackButton = false;
  currentLang = 'es';

  private router = inject(Router);
  private location = inject(Location);
  private translate = inject(TranslateService);

  constructor(public sidebarService: SidebarService) {
    const browserLang = this.translate.getBrowserLang();
    this.currentLang = browserLang === 'en' ? 'en' : 'es';
    this.translate.use(this.currentLang);

    this.translate.onLangChange.subscribe(event => {
      this.currentLang = event.lang;
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.showBackButton = event.urlAfterRedirects === '/' ? false : true;
    });
  }

  onMenuButtonClick() {
    this.sidebarService.toggle();
  }

  goBack() {
    this.location.back();
  }

  toggleLanguage() {
    this.currentLang = this.currentLang === 'es' ? 'en' : 'es';
    this.translate.use(this.currentLang);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
  }
}
